<div class="card-answer">
	<form [formGroup]="form" class="box-container">
		<ng-container formArrayName="answers">
			<ng-container
				*ngFor="let formAnswer of formAnswers.controls; let i = index; trackBy: trackByFn">
				<div [formGroupName]="i" class="box">
					<div class="box-image">
						<i
							class="fas fa-times-circle fa-lg icon-remove pointer"
							*ngIf="!_disabled"
							(click)="confirmDeletionAnswer(i, formAnswer.value, $event)"></i>

            <img [src]="formControlArray(i, 'answers', 'description').value" alt="img-answer">
					</div>
          <div class="wrapper-form-control">
            <div class="form-check ms-auto">
              <input class="form-check-input" type="checkbox" formControlName="isCorrect">
              <label class="form-check-label">
                Correcta
              </label>
            </div>
          </div>
				</div>
			</ng-container>
		</ng-container>

    <div class="box-image pointer" *ngIf="!_disabled" (click)="openContainerDocumentDialog()">
      <i class="fas fa-plus fa-lg"></i>
    </div>
	</form>
</div>
